import styled, { css } from 'styled-components';
import { GREY_10, FONT_SIZE } from '../../../utils/colors';

export const Wrapper = styled.div<{ filled?: boolean}>`
  position: relative;

  .label {
    font-weight: normal;
    position: absolute;
    font-size: calc(13px *  ${FONT_SIZE});
    pointer-events: none;
    left: 12px;
    top: 16px;
    transition: 0.2s ease all;
    line-height: 13px;
  }

  .as-placeholder {
    color: gray;
    font-size: ${FONT_SIZE > 1 ? '14px' : '11px'}!important;
  }

  .as-label {
    top: calc(-8px *  ${FONT_SIZE});
    font-size: ${FONT_SIZE > 1 ? '14px' : '11px'}!important;
    background: ${GREY_10};
    padding: 0 4px;
    margin-left: -4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 98%;
  }


  .ant-input {
    width: 100%;
    border: none !important;
  }

  .ant-input:focus, .ant-input-focused {
    box-shadow: none !important;
    border: none !important;
  }
  
  ${({ filled }) => filled && css`
    .ant-input {
      background: ${GREY_10} !important;
    }

    .as-label {
      background: #fff;
    }
  `}
`;
